import React from 'react';

export const Undo = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 5.519">
            <path d="M7.325 0a7.347 7.347 0 0 0-4.813 1.794L1.193.49A.7.7 0 0 0 0 .973V4.83a.7.7 0 0 0 .7.69h3.9a.691.691 0 0 0 .5-1.18L3.76 3.022a5.59 5.59 0 0 1 8.588 1.808.869.869 0 0 0 1.57-.745A7.357 7.357 0 0 0 7.325 0Z" />
        </svg>
    );
}